import {
  padStart,
} from 'lodash';

import {
  ExtDate,
  DATE_FORMAT,
} from '@/helpers/date';

export default () => {
  /**
   * Convert {@link LOCAL_DATE_TEMPLATE} type Object into ExtDate
   * @param {Object} dateObj - {@link LOCAL_DATE_TEMPLATE} type object
   * @returns {ExtDate}
   */
  const convertDateObjToDate = (dateObj) => { return new ExtDate().parse(`${dateObj.year}-${padStart(dateObj.month, 2, '0')}-${padStart(dateObj.day, 2, '0')}`, DATE_FORMAT); };
  /**
   * Return {@link LOCAL_DATE_TEMPLATE} type Object based on `date` param or local date
   * @param {Date} [date = new Date()]
   * @returns {{month: number, year: number, day: number}} - {@link LOCAL_DATE_TEMPLATE} type Object with according values
   */
  const getDateObj = (date = new Date()) => {
    return {
      day: padStart(+date.getDate(), 2, '0'),
      month: date.getMonth() + 1,
      year: date.getFullYear(),
    };
  };

  return {
    convertDateObjToDate,
    getDateObj,
  };
};
